import * as React from "react";
import type { ComponentProps, InputHTMLAttributes } from "react";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import { isPossiblePhoneNumber } from "react-phone-number-input";

import "react-phone-number-input/style.css";
import styles from "./PhoneNumberInput.module.css";

export type PhoneNumberInputProps = ComponentProps<
  typeof PhoneInputWithCountry
> & {
  id?: string;
  label?: string;
  placeholder?: string;
};

// Custom input for adding a floating label
// TODO: reuse components from Form, Input
const InputWithLabel = React.forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & { id?: string; label?: string }
>(({ id, label, ...inputProps }, ref) => (
  <div className={styles.inputContainer}>
    {label && (
      <label htmlFor={id} className={styles.label}>
        {label}
      </label>
    )}
    <input ref={ref} id={id} {...inputProps} />
  </div>
));
InputWithLabel.displayName = "InputWithLabel";

export function PhoneNumberInput({
  className = "",
  countrySelectProps,
  id,
  label,
  placeholder = " ",
  ...props
}: PhoneNumberInputProps) {
  return (
    <div className={styles.field}>
      <PhoneInputWithCountry
        id={id}
        label={label}
        className={className}
        countrySelectProps={{ unicodeFlags: true, ...countrySelectProps }}
        placeholder={placeholder}
        inputComponent={InputWithLabel}
        {...props}
      />
    </div>
  );
}

PhoneNumberInput.displayName = "PhoneNumberInput";

export { isPossiblePhoneNumber };
